import { baseUrl, publicUrl } from '$utils/env';

export const getAppURL = () => {
  const appBase = publicUrl || baseUrl;
  const appUrl = appBase.match(/^https?:\/\//)
    ? appBase
    : new URL(appBase, `${window.location.origin}/`).toString();

  // Remove trailing url if exists.
  const url = new URL(appUrl.replace(/\/$/, ''));
  return url;
};

export const getAppBasename = () =>
  getAppURL().pathname.replace(/\/$/, '') || '/';

/**
 * Create am absolute APP url to a resource. Useful when there's a base path in
 * the app url.
 *
 * @param {string} resource root url to the resource, if any.
 */
export const makeAbsUrl = (resource = '') =>
  `${getAppURL().href.replace(/\/$/, '')}${resource}`;
